export async function measureExecutionTime<
  T extends (...args: any[]) => Promise<any>
>(
  functionToMeasure: T
): Promise<(...args: Parameters<T>) => Promise<ReturnType<T>>> {
  return async function (...args: Parameters<T>): Promise<ReturnType<T>> {
    const startTime = performance.now();

    const result = await functionToMeasure.apply(null, args);

    const endTime = performance.now();
    console.log(
      `Execution time of ${functionToMeasure.name}: ${
        endTime - startTime
      } milliseconds`
    );

    return result;
  };
}
